import { render } from "./Records_backup.vue?vue&type=template&id=ca86c8ca"
import script from "./Records_backup.vue?vue&type=script&lang=js"
export * from "./Records_backup.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"

import exportComponent from "/home/forge/lf.m2geo.ie/releases/20261103161156/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Task/Partials/Records_backup.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ca86c8ca"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ca86c8ca', __exports__)) {
    console.log('reload')
    api.reload('ca86c8ca', __exports__)
  }
  
  module.hot.accept("./Records_backup.vue?vue&type=template&id=ca86c8ca", () => {
    console.log('re-render')
    api.rerender('ca86c8ca', render)
  })

}


export default __exports__